import "esbuild-css-modules-plugin-ns-css:src/artifacts/graphic/styles/tooltip.module.css";

export default {
  "container": "tooltip-module__container_vzrhVq__010",
  "content": "tooltip-module__content_vzrhVq__010",
  "fadeOut": "tooltip-module__fadeOut_vzrhVq__010"
};
      